// 牦牛酪蛋白产业园 · 6 家主体官网级详情内容
// 数据依据：6家公司设计规划.docx（统一版式：介绍/品牌定位/核心业务板块/柱状图数据/核心竞争优势/发展规划/主副标语）
// key 与 src/pages/ganzi/index.vue 中 parkCompanies 的 name 一一对应，用于点击饼图扇区联动打开弹层。
const companyInfo = {
  // 一、甘孜州雪域三千传媒有限公司
  '甘孜州雪域三千传媒有限公司': {
    color: '#5B8FF9',
    heroKeywords: '甘孜高原雪山全景、现代化电商直播间、产业园区航拍、新媒体传媒光影、助农直播场景、雪域通透质感、简约蓝色商务风、乡村振兴产业氛围、超宽屏全景构图',
    intro: '甘孜州雪域三千传媒有限公司是深耕甘孜炉霍本土，聚焦高原乡村振兴与产业数字化的综合型传媒运营企业。公司深度扎根甘孜藏区，深耕本土农牧、文旅产业多年，精准把握高原特色产品推广、县域园区运营、本地文旅宣传的核心需求。依托成熟的传媒策划、电商直播、园区托管、产品全链路运营能力，打造“内容宣传+直播销售+产业孵化+园区运维”一体化服务体系。累计服务甘孜本地企业、农牧合作社、文旅商户超80家，落地政企助农宣传、产业推广、园区运营项目30余个，是甘孜北路县域极具实力的本土传媒与产业运营服务商，持续助力高原特色产业品牌化、数字化、市场化发展。',
    positioning: '立足甘孜雪域本土，一站式产业园区运营+全域电商直播+品牌内容全案传媒服务商，深耕高原农牧文旅产业，用数字传媒打通甘孜特色产品线上线下产销链路，服务县域产业园区、本土企业、农牧合作社。',
    businesses: [
      { title: '电商直播全链路服务', desc: '可独立搭建标准化直播间6间，年均运营常态化直播场次超500场，承接政企助农专场、文旅专场、特产带货专场超80场。专业孵化本土主播30余名，涵盖全职、兼职新农人主播，覆盖抖音、视频号、快手、淘宝四大主流平台。年均助力本土高原特产线上销售额突破800万元，短视频引流作品年均产出1200条以上，单条最高曝光量突破50万，高效实现产品种草与流量转化。' },
      { title: '产业园区综合管理运营', desc: '具备整园托管运营能力，可承接1-2个县域电商产业园全流程运维服务。目前累计服务园区入驻商户、创客团队50余家，年均策划园区招商、展销、创业孵化活动20余场。负责园区直播间集群、仓储配套、创客孵化、日常运维全流程管理，园区入驻存活率稳定保持85%以上，有效激活县域电商产业集聚活力。' },
      { title: '全产业链产品运营', desc: '专注甘孜牦牛乳制品、青稞农特产、藏式手工艺品、文旅文创产品四大品类，累计包装打造本土特色产品40余款。搭建线上线下双渠道分销体系，线下合作商超、文旅特产店、景区门店60余家，线上覆盖全域电商渠道，年均完成特色产品产销对接超1000批次，助力本土农产品走出高原、走向全国市场。' },
      { title: '传媒全案配套业务', desc: '年均承接政企宣传片、纪录片、文旅短视频摄制项目50余个，完成品牌设计、广告物料制作、全域宣传推广项目百余项。可承办大型文旅展演、乡村振兴主题活动、产业展销活动，具备全流程策划、执行、宣发能力，累计服务县域政企宣传项目覆盖率达70%以上。' }
    ],
    chartData: [
      { label: '直播年场次', value: 500, unit: '场' },
      { label: '年带货销售额', value: 800, unit: '万' },
      { label: '年短视频产量', value: 1200, unit: '条' },
      { label: '孵化主播', value: 30, unit: '人' }
    ],
    advantages: [
      '本土深耕优势：深耕甘孜北路县域多年，熟悉本地产业政策、产品特性、文旅资源，无地域信息壁垒，服务响应效率远超外地服务商；',
      '全资质全业态覆盖：具备影视制作、网络直播、营业性演出全套合规资质，可承接各级政企大型宣传、展销、直播项目；',
      '产媒一体化闭环：实现内容宣传、流量引流、直播销售、园区孵化、渠道分销全闭环服务，一站式解决企业品牌、销售、孵化三大核心需求；',
      '成熟助农体系：深耕乡村振兴赛道，拥有稳定的政企合作资源与落地经验，助农项目落地成功率100%。'
    ],
    plans: {
      short: '升级8间标准化专业直播间，扩充全职主播及运营团队至40人；年均直播场次提升至800场，线上带货销售额突破1200万元；新增园区入驻商户30家，完善园区仓储、物流、孵化配套；打造10款甘孜网红爆款特产，提升本土产品市场知名度。',
      mid: '成为甘孜北路头部传媒电商运营品牌，服务本土企业超150家；落地2个标杆性县域产业园区运营项目，打造标准化园区运营体系；搭建本土主播孵化基地，年均培育专业新农人主播50名；拓展川内城市分销渠道，线下合作门店突破120家，年产值突破2000万元。',
      long: '构建甘孜全域产业传媒服务矩阵，覆盖全州各县市文旅、农特产业；打造集内容创作、直播电商、产业孵化、品牌输出、渠道供应链于一体的全域产业服务平台，成为甘孜乡村振兴数字传媒标杆企业。'
    },
    sloganMain: '雪域三千，传媒赋能甘孜产业新征程',
    sloganSub: '直播带货·园区运营·全域品牌内容服务商',
    projects: [
      { title: '炉霍县电商产业园整体托管运营项目', desc: '承接园区直播间集群运维、创客孵化、仓储配套、招商展销全流程管理，运营 50 余家园区商户，常态化开展创业孵化展销活动，是炉霍县域核心电商园区运营服务商。' },
      { title: '甘孜北路助农直播专场全年合作项目', desc: '搭建 6 间标准化直播间，全年承接 80+ 场政企助农直播，覆盖牦牛乳制品、青稞特产、藏式文创，年度线上带货总额 800 万元；孵化 30 余名本土新农人主播。' },
      { title: '炉霍乡村振兴全域宣传全案项目', desc: '年度产出 1200+ 条文旅、产业短视频，承接 50 余部政企宣传片、产业纪录片摄制；负责县域文旅节庆、农特产展销活动全流程策划执行，县域政企宣传项目覆盖率 70%。' },
      { title: '高原特色产品品牌包装运营项目', desc: '打造 40 余款甘孜本土特产标准化产品，线下合作 60 余家景区、商超特产门店，打通线上线下产销渠道，年均完成 1000+ 批次农特产品产销对接。' },
      { title: '县域新媒体矩阵代运营项目', desc: '托管乡镇、产业园区官方短视频账号，提供图文拍摄、流量投放、活动策划一体化新媒体服务，多条单条短视频曝光突破 50 万。' }
    ]
  },

  // 二、甘孜州康创未来数字科技有限公司
  '甘孜州康创未来数字科技有限公司': {
    color: '#0CFBFF',
    heroKeywords: '高原智慧园区指挥中心、大数据可视化大屏、数字化工业生产线、蓝色科技光线、数据网格、智能工业场景、未来数字科技风、高海拔智慧产业基地、超宽屏科技全景',
    intro: '甘孜州康创未来数字科技有限公司是甘孜本土专注产业数字化、工业智改数转、智慧园区建设的核心科技服务商，依托头部科技企业技术支撑与本地产业资源，深耕高原工业、农牧产业、文旅、政企数字化领域。公司聚焦高海拔地区产业数字化痛点，专注工厂智能化升级、园区智慧指挥中心搭建、产业大数据平台开发、数字化展厅建设等核心业务，是炉霍牦牛酪蛋白省级现代园区指定数字化承建单位。累计落地各类数字化改造、智慧平台建设项目40余个，服务本土工厂、园区、政企单位30余家，凭借适配高原环境的定制化数字方案、全流程落地交付能力，成为甘孜产业转型升级的核心赋能企业。',
    positioning: '甘孜本土产业数字化转型一站式服务商，专注工厂智转数改、园区智慧指挥中心、产业大数据平台搭建，以数字技术赋能高原农牧加工、文旅、工业全产业链升级。',
    businesses: [
      { title: '工厂数字化升级（智转数改）', desc: '深耕高原农牧加工工厂智能化改造，成功落地国内首条全数字化牦牛酪蛋白生产线升级项目。可为各类加工厂搭建生产中控系统、数据溯源系统、可视化监测大屏，实现生产流程、能耗、物料、质量全数据可视化管控。已完成10余家高原加工企业智改数转落地，改造后企业生产效率平均提升35%以上，人工成本降低20%，产品良品率提升至98%以上，完美适配高海拔低温、低氧的生产环境。' },
      { title: '园区智慧指挥中心建设', desc: '专注产业园区全域智慧化建设，可定制弧形大数据可视化平台、全域安防监控、仓储物流管控、产销数据统计、资源地图系统。已建成炉霍牦牛产业园区智慧指挥中心，实现园区20+核心数据实时监测、30+点位全域管控、日产销数据分钟级更新。单园区可实现日均数据处理量10万+条，大幅提升园区管理效率，降低运维成本40%以上。' },
      { title: '产业数字化平台开发', desc: '自主研发牦牛产业数字交易平台、农牧原料收购溯源平台、供应链管理系统等多款行业专属系统。累计开发定制化数字平台15套，实现原料收购、生产加工、产品销售、溯源查询全链路数字化。平台年均处理产业交易数据超50万条，助力高原农牧产业实现标准化、透明化、数字化运营。' },
      { title: '全行业数字化赋能服务', desc: '承接文旅街区数字化、政企数字展厅、安防显示集成、软硬件定制开发及运维服务。累计建设数字化展厅12座、智慧文旅点位20余个，服务政企数字化项目20余项，项目交付合格率100%，售后运维响应时效2小时内，稳居甘孜本土数字科技服务前列。' }
    ],
    chartData: [
      { label: '生产效率提升', value: 35, unit: '%' },
      { label: '人工成本降低', value: 20, unit: '%' },
      { label: '运维成本降低', value: 40, unit: '%' },
      { label: '产品良品率', value: 98, unit: '%' }
    ],
    advantages: [
      '技术背书雄厚：依托头部科技企业硬件与技术支持，实现软硬件一体化自主交付，无需依赖外地供应商，交付周期缩短30%；',
      '高原适配性极强：深耕高海拔产业数字化改造，针对性解决高寒环境设备卡顿、冻损、数据延迟等行业痛点，方案适配度远超通用数字化产品；',
      '全链条交付能力：集方案设计、设备部署、系统开发、施工落地、长期运维于一体，一站式交付，综合服务成本更低；',
      '产业落地经验丰富：深度服务省级牦牛产业园区，熟悉高原农牧加工产业全流程，项目落地贴合本土产业实际需求。'
    ],
    plans: {
      short: '完善牦牛产业数字化标杆项目迭代升级，新增落地工厂智改数转项目20个、智慧园区项目5个；扩充技术研发团队至25人，优化3款核心产业数字系统，提升系统自动化、智能化水平；实现年服务政企、工业企业数量突破50家，年产值增长40%。',
      mid: '打造甘孜州产业数字化标杆品牌，覆盖全州18个县市核心产业园区与重点加工企业；自主研发5套以上高原专属数字化系统，形成标准化产品体系；承接州级重大数字化转型项目，成为甘孜智转数改核心合作服务商，年产值突破3000万元。',
      long: '构建甘孜全域产业数字化服务生态，覆盖农牧、文旅、工业、政务全领域；打造川西高原特色产业数字化解决方案体系，辐射川西周边藏区，成为西南高原地区极具影响力的数字产业赋能平台。'
    },
    sloganMain: '数字创未来，智赋甘孜全产业转型升级',
    sloganSub: '工厂数字化｜园区指挥中心｜产业大数据平台定制服务商',
    projects: [
      { title: '炉霍牦牛酪蛋白省级现代产业园数字化整体建设项目（标杆核心项目）', desc: '国内首条全数字化牦牛酪蛋白生产线升级改造；建设园区大数据智慧指挥中心、弧形可视化大屏、原料收购溯源系统、数字化参观展厅、产学研数字实验室；实现生产、仓储、产销全流程数据实时管控，园区日均处理产业数据 10 万+ 条，改造后工厂生产效率提升 35%。' },
      { title: '炉霍县秋日河街区数字化建设项目（政府采购中标 330.1 万元）', desc: '街区数字文旅大屏、全域安防监控、客流统计系统、数字导览、线上文旅宣传平台搭建，京东方全套显示硬件配套，打造炉霍城区数字文旅示范街区。' },
      { title: '甘孜北路农牧加工企业智转数改改造项目（10 余家工厂落地）', desc: '为本地食品、牦牛乳加工厂定制生产中控、能耗监测、质量溯源数字化系统，解决高海拔低温设备数据延迟问题，改造后企业人工成本降低 20%，良品率提升至 98%。' },
      { title: '牦牛产业数字交易平台开发项目', desc: '自主研发线上奶渣收购、产销交易系统，覆盖甘孜北路 8 县牦牛养殖户，平台年处理产业交易数据 50 万条，三年规划奶渣年收购量 2500 吨、交易额破 1 亿元。' },
      { title: '政企数字化展厅建设项目（12 座展厅落地）', desc: '完成乡镇政务展厅、产业园区展示中心、乡村振兴数字展馆软硬件一体化施工，配套 2 小时本地售后运维响应体系。' }
    ]
  },

  // 三、甘孜州川妤生物科技有限公司
  '甘孜州川妤生物科技有限公司': {
    color: '#42AAFF',
    heroKeywords: '高原牦牛牧场、纯净牦牛乳脂肌理、天然生物萃取工艺、轻奢洗护产品合集、柔和浅金+纯白质感、自然纯净风、高原天然科创氛围、产品精致静物全景',
    intro: '甘孜州川妤生物科技有限公司是甘孜炉霍本土专注牦牛乳脂生物研发、高原天然洗护护肤产品研发、生产与销售的特色生物科技企业。公司立足甘孜得天独厚的牦牛产业资源，深耕牦牛乳脂衍生生物原料研发与应用，聚焦天然、温和、适配高原肤质的生活美容洗护产品赛道。依托本地优质牦牛乳脂核心原料，结合现代化生物萃取工艺，打造洗发、沐浴、护肤、清洁全系列日化产品，填补了甘孜高原牦牛乳脂日化产品的市场空白。公司集原料研发、产品生产、品牌运营、渠道销售于一体，主打高原天然、无刺激、滋养修护的产品特性，适配高原干燥气候与敏感肌人群，是甘孜极具特色的本土生物科创企业。',
    positioning: '甘孜本土牦牛乳脂天然洗护护肤品牌，深挖高原牦牛乳脂天然护肤营养，研发温和无刺激生活美容洗护全系列产品，打造高原特色天然日化国货标杆品牌。',
    businesses: [
      { title: '清洁洗护系列', desc: '核心推出牦牛乳脂滋养洗发露、抑菌保湿洗手液、温和滋养沐浴露、手工冷制皂、多功能护肤香皂5大核心单品。所有产品均添加≥12%高原原生牦牛乳脂萃取精华，无荧光剂、无刺激性化工添加剂，温和适配高原干燥、紫外线强的特殊环境。目前单品月均产能可达8000件，全线产品合格率100%，用户敏感肌适配率达95%以上。' },
      { title: '身体护肤系列', desc: '主打牦牛乳脂润肤乳、滋养身体霜、保湿护手霜三大护肤产品，聚焦高原肌肤干燥、起皮、暗沉问题，依托乳脂蛋白滋养修护配方，实现长效锁水保湿。产品上市以来，复购率稳定保持38%以上，远超普通日化产品行业均值，深受本地居民与游客认可。' },
      { title: '原料与代工业务', desc: '自主完成牦牛乳脂原料提纯、萃取、精炼工艺，年均可供应优质乳脂原料5吨以上，可承接洗护产品OEM/ODM定制代工服务，可为文旅企业、政企单位定制专属礼盒产品。累计承接定制代工、礼盒订单超万件，服务本土及外地合作企业20余家。' },
      { title: '全渠道销售体系', desc: '搭建线上电商、线下实体、政企定制三大渠道，线上入驻主流电商平台、短视频带货渠道，线下覆盖甘孜景区、特产店、商超40余家。年均产品销量突破10万件，文旅伴手礼销量占比达45%，成为甘孜特色文旅衍生爆款产品。' }
    ],
    chartData: [
      { label: '年销量', value: 10, unit: '万件' },
      { label: '乳脂精华含量', value: 12, unit: '%' },
      { label: '敏感肌适配率', value: 95, unit: '%' },
      { label: '产品复购率', value: 38, unit: '%' }
    ],
    advantages: [
      '原料独家稀缺：依托炉霍牦牛产业集群，坐拥原生高原牦牛乳脂核心原料，原料天然、营养成分远超普通动植物护肤原料，具备不可复制的地域资源优势；',
      '配方专属适配：针对高原气候定制研发，专攻干燥、敏感、紫外线损伤肌肤，差异化优势显著；',
      '赛道稀缺性高：国内牦牛乳脂日化产品布局极少，是甘孜独有的特色生物衍生产品，市场竞争力突出；',
      '产销一体化：自主研发、可控产能、全渠道销售，成本可控、品控稳定，兼具民生用品与文旅伴手礼双重属性。'
    ],
    plans: {
      short: '迭代升级3款核心产品配方，提升乳脂精华含量至15%以上；新增5款细分护肤、洗护单品，完善产品矩阵；扩建生产线，将月产能提升至1.5万件；拓展川内10个重点城市销售渠道，年销量突破20万件，线上店铺粉丝量突破5万。',
      mid: '建成标准化生物研发实验室与无尘生产车间，实现原料萃取、产品生产、质检全流程自主可控；打造川西牦牛乳脂日化标杆品牌，线下合作门店突破100家；深耕文旅伴手礼市场，占据甘孜特色日化80%以上市场份额，年产值突破1500万元。',
      long: '深耕牦牛生物衍生技术研发，拓展美妆、康养、母婴护肤等细分赛道；打造集原料研发、产品生产、品牌运营、技术输出于一体的高原生物科技企业，成为全国牦牛乳脂日化细分领域头部品牌。'
    },
    sloganMain: '高原牦牛乳脂，天然呵护每一寸肌肤',
    sloganSub: '本土生物研发｜洗护·护肤·手工皂全系列高原日化品牌',
    projects: [
      { title: '牦牛乳脂洗护系列产品自研量产项目', desc: '依托炉霍牦牛产业集群，自主研发 5 款清洁洗护、3 款身体润肤产品，生产线月产能 8000 件，全线产品添加 12% 原生牦牛乳脂萃取精华，建成本地独有的高原乳脂日化生产线。' },
      { title: '炉霍文旅伴手礼定制供货项目', desc: '对接全县 40 余家景区、特产商超供货，开发成套洗护礼盒，文旅伴手礼销量占总销量 45%；承接政企单位节日定制礼盒订单，累计交付定制礼盒万余套。' },
      { title: '牦牛乳脂原料对外供应合作项目', desc: '自主完成乳脂提纯精炼工艺，年均对外供应优质牦牛乳脂原料 5 吨，为周边美妆、洗护小企业提供原料配套，合作企业 20 余家。' },
      { title: 'OEM/ODM 洗护代工合作项目', desc: '为本地合作社、文旅企业提供手工皂、润肤乳代工服务，支持配方微调、品牌贴牌，打造甘孜特色日化代工配套基地。' },
      { title: '线上全域电商铺货项目', desc: '入驻抖音、淘宝、视频号电商渠道，联动章谷臻品、雪域三千传媒开展直播带货，年度产品总销量突破 10 万件，产品复购率 38%。' }
    ]
  },

  // 四、炉霍创智环保设备制造有限公司
  '炉霍创智环保设备制造有限公司': {
    color: '#2A54A2',
    heroKeywords: '高原绿水青山、环保设备生产车间、污水处理工程实景、绿色生态科技、洁净工业厂区、高原生态治理场景、低饱和绿色商务风、智造环保产业全景',
    intro: '炉霍创智环保设备制造有限公司是甘孜炉霍本土唯一集环保设备自主制造、污水综合治理、厂房环保升级、设备运维服务于一体的实体环保科技企业。公司深耕川西高原高寒地区环保治理领域，专注解决高原乡镇生活污水、农牧加工废水、厂房环保改造、水土治理等核心痛点。针对高海拔低温、冻融、水质特殊等环境特点，定制研发适配高原的环保设备与治理方案，打破外地设备不适配高原环境、售后响应慢、运维成本高的行业难题。累计自主生产环保设备300余台（套），落地污水治理、厂房环保改造工程60余项，服务甘孜本土工厂、乡镇、园区、政企单位40余家，是甘孜高原生态环保治理的核心本土实体企业。',
    positioning: '炉霍本土环保设备生产+污染治理工程一体化服务商，专注高原农牧加工厂、产业园、乡镇生活污水治理、厂房环保节能改造，定制适配高海拔高寒环境的环保设备与治理方案。',
    businesses: [
      { title: '环保设备自主制造', desc: '拥有标准化生产厂区，可自主生产污水处理成套设备、污泥脱水设备、紫外线消毒装置、智能自控系统、环境在线监测仪器等10余类核心设备。年均产能可达120台（套），设备均经过高寒环境适配改造，可耐受-25℃低温环境，冬季设备稳定运行率达99%，彻底解决传统设备冬季冻堵、效率骤降问题。设备本地生产、本地交付，交付周期较外地厂商缩短50%。' },
      { title: '污水综合治理工程', desc: '承接农牧加工厂区生产废水、乡镇生活污水、河道水体净化、污泥无害化处理等全品类工程。已落地乡镇污水处理站改造、厂区废水治理项目30余个，累计治理污水日处理能力达8000立方米。治理后水质100%达标排放标准，厂区废水循环利用率提升至60%，乡镇污水治理覆盖率助力区域生态达标率提升90%。' },
      { title: '厂房环保升级改造', desc: '专注高原加工车间废气收集、废水管网改造、节能降噪、环保合规整改、在线监测系统安装等改造工程。累计完成牦牛乳脂加工、农牧食品加工等厂房环保升级28家，帮助100%合作企业顺利通过环保验收，企业环保合规成本平均降低25%，能耗降低18%。' },
      { title: '配套运维服务', desc: '提供设备安装、定期检修、水质检测、运维托管、备品备件供应全流程服务。建立24小时本地运维响应机制，县域内2小时到场、州内4小时到场服务。目前长期托管运维项目22个，设备年均故障率控制在2%以内，运维满意度100%。' }
    ],
    chartData: [
      { label: '年设备产能', value: 120, unit: '套' },
      { label: '设备冬季稳定率', value: 99, unit: '%' },
      { label: '水质达标率', value: 100, unit: '%' },
      { label: '设备年均故障率', value: 2, unit: '%' }
    ],
    advantages: [
      '本土实体产能：甘孜少数具备自主设备制造能力的环保企业，无需异地采购，交付快、成本低、备件充足；',
      '高原专属适配：所有设备与方案均针对川西高寒、低压、特殊水质定制，适配性远超通用环保设备；',
      '全闭环服务：集设备生产、工程施工、安装调试、长期运维于一体，一站式解决企业环保合规需求；',
      '产业深度适配：深耕农牧加工废水治理，熟悉牦牛、青稞加工产业污染特性，落地案例丰富、治理效果稳定。'
    ],
    plans: {
      short: '升级生产厂区，新增2条智能化设备生产线，年产能提升至180台（套）；新增落地乡镇污水治理、厂房改造项目40个，服务企业突破60家；优化3款高原专属环保设备，进一步提升低温运行稳定性，降低设备能耗10%。',
      mid: '打造川西高原环保设备智造基地，丰富设备品类至15类以上；承接州级生态环保重点项目，实现甘孜北路乡镇污水治理项目全覆盖；建立标准化环保工程施工与运维体系，年产值突破2500万元，成为川西高原环保治理标杆企业。',
      long: '拓展土壤修复、大气治理、固废处理等新业务赛道，构建全域生态环保服务体系；实现设备智能化、模块化、标准化生产，辐射整个川西藏区，成为西南高海拔地区领先的环保设备制造与生态治理服务商。'
    },
    sloganMain: '创智环保，守护高原绿水青山',
    sloganSub: '污水治理设备制造｜厂房环保升级｜高原环保工程一站式服务商',
    projects: [
      { title: '炉霍牦牛酪蛋白加工园区生产废水治理项目', desc: '定制高原耐寒污水处理成套设备，配套污泥脱水、紫外线消毒、PLC 自控系统，厂区废水循环利用率 60%，100% 达标排放，长期托管运维。' },
      { title: '炉霍乡镇生活污水处理站改造项目（30 余个村镇落地）', desc: '针对川西零下 25℃低温环境改造设备，解决冬季冻堵难题，设备稳定运行率 99%，全域乡镇污水治理达标覆盖率提升 90%。' },
      { title: '28 家农牧加工厂环保厂房升级改造项目', desc: '车间废气收集、废水管网改造、节能降噪、环保在线监测设备安装，全部合作企业一次性通过环保验收，企业环保运营成本平均降低 25%。' },
      { title: '本地环保设备自产交付项目', desc: '自有标准化生产车间，年均生产污水处理、环境监测设备 120 套，本地交付周期比外地厂商缩短 50%，累计产出 300 余台套环保设备服务甘孜各县。' },
      { title: '全域环保设备长期运维托管项目（22 个长期运维点位）', desc: '建立 2 小时县域、4 小时州内上门运维机制，设备年均故障率控制 2% 以内，覆盖产业园、乡镇污水站、食品加工厂。' },
      { title: '炉霍县乡村振兴环保帮扶合作项目（政府认定帮扶企业）', desc: '为各村集体养殖合作社免费提供污水治理方案、设备检修公益服务，助力农牧产业绿色合规发展。' }
    ]
  },

  // 五、甘孜州章谷臻品电子商务有限公司
  '甘孜州章谷臻品电子商务有限公司': {
    color: '#3CB0FF',
    heroKeywords: '甘孜高原农特产品合集、青稞牦牛特色物产、助农直播带货现场、乡村丰收肌理、温暖暖色电商氛围、县域乡村振兴新零售场景、产品陈列全景视觉',
    intro: '甘孜州章谷臻品电子商务有限公司是炉霍县域核心本土电商龙头企业，专注甘孜高原农特产品、文创产品的品牌打造、全域电商销售、直播带货与供应链运营。公司深耕甘孜北路特色产业资源，聚焦青稞、牦牛制品、藏式文创、高原零食等本土优质产品，打造自有电商品牌“溜溜小厨娘”。依托成熟的直播运营、店铺运维、产品包装、供应链分销、电商孵化能力，打通高原农产品上行全链路。累计运营线上店铺10余家，打造爆款农特产品20余款，年均带动本土特产线上销售额超1000万元，培育本土电商创业者40余人，是助力炉霍及甘孜乡村振兴、特产市场化的核心电商运营主体。',
    positioning: '炉霍本土县域农特产品电商运营龙头企业，聚焦甘孜高原青稞、牦牛制品、藏式文创特产，以直播电商、全域线上店铺为核心渠道，打通高原农产品上行通道，打造县域特色农产品线上标杆品牌。',
    businesses: [
      { title: '线上直播带货运营', desc: '搭建3间常态化标准化直播间，全职运营主播、运营团队15人，年均开展常态化直播600场以上，助农专项直播100余场。覆盖抖音、视频号、拼多多、淘宝四大主流平台，单场最高带货销售额突破12万元，年均直播引流曝光量超3000万次，有效撬动高原特产线上流量市场。' },
      { title: '全域电商产品销售', desc: '运营自有品牌“溜溜小厨娘”全系产品，涵盖黑青稞糌粑、牦牛奶制品、藏式手工皂、青稞零食等20余款核心单品。搭建一件代发、批发、零售三重销售体系，合作本土农牧合作社30余家，稳定供应链货源。年均线上单品出货量超15万件，自有品牌产品复购率达42%，稳居甘孜本土电商品牌复购率前列。' },
      { title: '电商品牌全案服务', desc: '为本土中小企业、合作社提供产品包装设计、视觉升级、详情页制作、营销策划、礼盒定制一站式服务。累计完成产品品牌升级、包装优化50余款，定制文旅、企业礼盒8000余套，助力本土产品提升品牌溢价与市场竞争力。' },
      { title: '电商孵化与培训', desc: '常态化开展新农人电商培训、开店孵化、短视频运营教学，年均举办公益培训15场次，累计培训农牧民、创业青年600余人次，成功孵化本土个人电商店铺35家，带动200余户农户实现农产品线上增收。' }
    ],
    chartData: [
      { label: '年直播场次', value: 600, unit: '场' },
      { label: '年曝光', value: 3000, unit: '万' },
      { label: '年出货', value: 15, unit: '万件' },
      { label: '品牌复购率', value: 42, unit: '%' }
    ],
    advantages: [
      '本土供应链优势：深耕甘孜北路，联动30+合作社，掌握稳定、优质的高原特产一手货源，货源性价比、品质可控性远超外地电商；',
      '自有成熟品牌：“溜溜小厨娘”已形成标准化产品体系与市场口碑，具备成熟销售数据与粉丝基础；',
      '政企深度合作：承接县域乡村振兴电商助农项目，享受政策扶持，资源整合能力强；',
      '轻量化全链路服务：从货源、包装、运营、直播、分销到孵化一站式落地，低门槛助力本土产业线上化。'
    ],
    plans: {
      short: '扩充直播间至5间，运营团队增至25人；新增15款特色爆款产品，优化自有品牌产品包装与品控；年线上销售额突破1800万元，孵化本土电商店铺50家，培训新农人800人次。',
      mid: '打造甘孜州县域电商标杆品牌，自有品牌“溜溜小厨娘”成为全州知名农特产品牌；搭建完善的县域电商供应链仓储中心，实现货源统一分拣、发货、售后；合作合作社突破60家，年销售额突破3500万元，带动300户以上农户稳定增收。',
      long: '构建甘孜全域农特产品电商集散中心，整合全州特色产品资源；打造集品牌孵化、直播运营、供应链仓储、电商培训、产品外销于一体的综合性电商产业平台，成为甘孜乡村振兴电商领军企业。'
    },
    sloganMain: '章谷臻品，把甘孜高原好物送到千家万户',
    sloganSub: '本土直播电商｜高原农特产品全域线上运营服务商',
    projects: [
      { title: '自有品牌「溜溜小厨娘」全产业链运营项目', desc: '打造黑青稞糌粑、牦牛奶制品、藏式手工皂等 20 余款爆款单品，搭建零售、批发、一件代发体系，年线上出货 15 万件，品牌复购率 42%。' },
      { title: '常态化农特产品直播带货项目', desc: '3 间自有标准化直播间，全年 600+ 场常规直播、100+ 场助农专项直播，覆盖四大电商平台，年度直播总曝光 3000 万次，单场最高销售额 12 万元。' },
      { title: '炉霍新农人电商培育孵化项目', desc: '年均 15 场公益电商培训，累计培训 600 余名农牧民、创业青年，孵化 35 家本土个人电商店铺，带动 200 余户农户线上增收。' },
      { title: '甘孜本土合作社供应链合作项目', desc: '联动 30 余家青稞、牦牛养殖合作社，稳定特产一手货源，统一包装、仓储、发货，为县域农户打通线上外销渠道。' },
      { title: '618、双 11 全域电商节联合推广项目', desc: '联合炉霍县互联网文旅推广协会、融媒体中心举办“炉霍好物出山记”大型直播电商活动，承接全县农特产线上展销。' },
      { title: '产品品牌视觉升级定制项目', desc: '为本地中小企业、合作社完成 50 余款农特产品包装、详情页设计，定制 8000 余套政企、文旅礼品礼盒。' }
    ]
  },

  // 六、炉霍县互联网文化旅游推广协会
  '炉霍县互联网文化旅游推广协会': {
    color: '#8B5CF6',
    heroKeywords: '炉霍康巴民俗风光、高原自然文旅风景、新媒体短视频传播、公益培训活动场景、文旅产业融合氛围、清新雅致政企公益风、全域文旅全景画面',
    intro: '炉霍县互联网文化旅游推广协会是经民政部门登记、经信商务局主管的非营利性公益行业社会组织，立足炉霍文旅与电商产业融合发展核心需求，链接政府、企业、合作社、文旅从业者、电商创业者，搭建县域文旅电商公共服务平台。协会深耕炉霍康巴民俗文化、高原文旅资源、特色农产资源，专注文旅线上推广、行业人才培育、产业资源对接、政企桥梁搭建、行业规范引领。目前吸纳会员单位及个人从业者120余家/人，涵盖本地传媒、电商、生物科技、环保、文旅商户等全行业主体，年均开展各类公益培训、文旅推广、产业交流活动30余场，是推动炉霍文旅数字化、电商产业化、产业融合化发展的核心公益服务平台。',
    positioning: '炉霍县官方背书文旅电商行业公益服务平台，链接政府、文旅企业、农牧合作社、直播从业者、旅游商户，整合互联网线上资源，推广炉霍康巴文旅、高原农特产品，培育本地文旅电商复合型人才，推动县域文旅+电商融合高质量发展。',
    businesses: [
      { title: '文旅资源线上整合推广', desc: '统筹炉霍神山、民俗、户外、乡村文旅等20+核心文旅资源，年均策划线上文旅打卡、短视频推广、达人采风活动12场以上。累计产出文旅宣传短视频、图文素材1500余条，全网累计曝光量超5000万次，有效提升炉霍文旅知名度与线上引流能力，带动县域文旅消费年均增长20%以上。' },
      { title: '会员综合服务', desc: '现有在册会员120余家（人），涵盖企业会员28家、个体从业者会员92人。为会员提供政策解读、流量扶持、资源对接、展销资源共享、行业维权等免费服务，年均对接政企合作资源40余项，帮助会员企业争取产业扶持、项目合作机会20余次，会员服务覆盖率100%。' },
      { title: '行业人才培育培训', desc: '常态化开展直播带货、短视频创作、文旅新媒体运营、电商运营公益培训，年均举办专项培训18场次，累计培育本土文旅主播、电商创业者800余人次，其中30%学员实现自主创业、灵活就业，为县域数字产业培育了核心人才梯队。' },
      { title: '政企桥梁对接', desc: '承接政府文旅宣传、助农电商、产业孵化专项工作，年均反馈行业发展诉求、产业调研报告10余份，协助主管部门规范县域电商、文旅行业发展。年均组织跨区域行业交流、政企座谈活动8场，有效打通政企沟通、产业联动通道。' },
      { title: '产业融合活动策划', desc: '每年策划举办线上文旅直播节、农特产品电商展销会、民俗文化推广沙龙、创业交流会等品牌活动15场以上，累计带动本土特产销售额超600万元，有效推动炉霍文旅资源与特色农产品深度融合发展。' }
    ],
    chartData: [
      { label: '年度总活动', value: 30, unit: '场' },
      { label: '累计宣传曝光', value: 5000, unit: '万' },
      { label: '培育人才', value: 800, unit: '人次' },
      { label: '现有会员', value: 120, unit: '家/人' }
    ],
    advantages: [
      '官方权威背书：由县经信商务局主管、民政局正规登记，精准对接县域产业政策与专项扶持资源，公信力、专业性极强；',
      '公益普惠属性：所有培训、资源对接、行业服务均为公益免费，全方位赋能本土创业者与中小企业；',
      '全域资源整合：联动本地5家核心产业企业，覆盖传媒、电商、生物科技、环保、数字科技全赛道，产业联动优势突出；',
      '落地经验成熟：常年常态化开展各类推广、培训、交流活动，拥有完善的行业服务体系与成熟的活动运营经验。'
    ],
    plans: {
      short: '扩充会员体量至180家/人，吸纳更多文旅、电商、乡村创业主体入驻；年均开展公益培训20场、品牌文旅活动18场，年培育本土人才1000人次；新增全网文旅宣传曝光量突破8000万次，助力县域文旅、农特产品线上影响力大幅提升。',
      mid: '打造炉霍文旅电商行业标杆协会，建立标准化人才培育体系、行业服务体系、资源对接体系；打造3个县域文旅电商品牌活动IP，形成常态化产业赋能机制；会员服务覆盖全县所有乡镇，成为甘孜州文旅电商融合发展示范社会组织。',
      long: '构建全域文旅电商产业服务生态，联动全州文旅、电商资源，打造川西高原文旅电商交流推广核心平台；持续深耕人才培育、产业赋能、品牌推广，助力炉霍实现文旅产业化、产业数字化、品牌全国化发展。'
    },
    sloganMain: '互联炉霍文旅，共拓高原数字振兴之路',
    sloganSub: '文旅推广·电商赋能·人才培育·政企行业交流平台',
    projects: [
      { title: '格杰神山线上打卡文旅推广项目', desc: '全年策划多场户外达人采风、登山打卡活动，发动摄影、旅游达人产出千条文旅短视频，全网曝光 5000 万+，提升炉霍神山民俗文旅知名度。' },
      { title: '西博会「云上甘孜」官方直播协办项目（省级展会）', desc: '协会会长带队组织 24 名本土新农人主播，开展 16 场高原特产直播带货，展会线上销售额 42.8 万元，联动全州特色农产品对外推广。' },
      { title: '「炉霍好物出山记」618、双 11 电商狂欢季主办项目', desc: '联合县委县政府、融媒体中心、章谷臻品、雪域三千传媒举办年度大型线上展销活动，联动本地 5 家产业企业集中带货，年度带动特产销售 600 万元以上。' },
      { title: '县域文旅电商人才公益培训项目', desc: '年均 18 场短视频、直播运营公益培训，累计培育 800 余名本土主播、电商创业者，30% 学员自主创业就业。' },
      { title: '民族团结街全民打卡宣传活动', desc: '免费为本地摄影、歌舞、网红达人提供拍摄扶持，设置万元现金激励，全网传播炉霍藏式民俗、城市文旅风貌。' },
      { title: '跨县域产业交流、政企座谈研讨项目', desc: '年均 8 场行业交流沙龙，对接政府产业扶持政策，收集行业发展诉求，每年向主管部门提交 10 余份产业发展调研报告，搭建政企、企业间资源对接桥梁。' }
    ]
  }
}

export default companyInfo
